import { PropTypes } from 'prop-types';
import { Button } from '@mui/material';
import { useGrowers } from '../../hooks/use-growers';
import { useSendToDeere } from './send-to-deere-context';

SendToDeereButton.propTypes = {
  prescriptions: PropTypes.arrayOf(PropTypes.object),
};

export function SendToDeereButton(props) {
  const { selected: grower } = useGrowers();
  const dialog = useSendToDeere();

  if (!grower?.deereId) return null;

  return (
    <Button
      disabled={!props.prescriptions?.length}
      onClick={() => dialog.open(props)}
    >
      Send to John Deere
    </Button>
  );
}
